// extracted by mini-css-extract-plugin
export default {"tabs":"show_tabs_KJv6s"};